import { merge } from 'rxjs'
import type { Epic } from '../../index.ts'
import { orderWizardEpicList } from './OrderWizardEpics.ts'
import { resilient } from './resilient.ts'
import { wizardRepositories } from '../../../Services/OrderWizard/repository/index.ts'

export const orderWizardEpics: Epic = (action$, state$, dependencies) => {
  const wizardDependencies = { ...dependencies, ...wizardRepositories }
  return merge(...orderWizardEpicList.map((epic) => resilient(epic)(action$, state$, wizardDependencies)))
}
